<!-- クーポンコード入力画面 -->
<template>
  <div class="main">
    <header-title title="クーポンコードを利用する" />
    <!-- 読み込み中 -->
    <Progress :title="isProcessing.message" v-if="isProcessing.flag" />
    <!-- クーポンフォームここから -->
    <div class="welcho-code-wrapper" v-else>
      <code-form
        @submit="onSubmit"
        @required="toggleShowRequiredMessage"
        @reset="reset"
        :validated="validated"
        :showRequiredMessage="showRequiredMessage"
      />
    </div>
  </div>
</template>

<script>
import { functions } from "@/firebase/index.js";
import { db } from "../firebase/index";
import HeaderTitle from "../design/HeaderTitleSlot";
import codeForm from "../components/molecules/wellcho/codeForm.vue";
import Progress from "../components/atoms/Progress";

export default {
  data() {
    return {
      couponCode: "",
      showRequiredMessage: false,
      validated: false,
      charge: false,
      isProcessing: {
        flag: false,
        message: "クーポン検証中...",
      },
    };
  },
  components: {
    HeaderTitle,
    Progress,
    codeForm,
  },
  methods: {
    validate(val) {
      this.validated = val;
    },
    toggleShowRequiredMessage(val) {
      this.showRequiredMessage = val;
    },
    reset() {
      this.validate(false);
      this.toggleShowRequiredMessage(false);
    },
    listen() {
      // selvyからの診断結果を取得
      db.ref(
        `/selvy/${this.$store.state.auth.user.uid}/${
          this.$store.getters["karte/getDiagnosisDate"]
        }`
      ).on(
        "value",
        (snapshot) => {
          if (this.charge) {
            // ページ遷移
            alert(this.$t("aiPredictionReport.analyzeSuccess"));
            const diagnosisDate = this.$store.getters["karte/getDiagnosisDate"];
            this.$store.dispatch("selvy/setDiagnosisDate", {
              date: diagnosisDate,
            });
            this.$router.push({ name: "report" });
          }
        },
        () => {
          // エラー 支払い成功で診断失敗の場合の処理を要検討
          alert(this.$t("aiPredictionReport.failedToSaveTheDiagnoisOnServer"));
        }
      );
    },
    // クーポンコードのサブミット
    async onSubmit(code) {
      this.$set(this.isProcessing, "flag", true);

      try {
        // karteデータ登録
        await this.$store.dispatch(
          "karte/sendKarteToFirebaseByCharge",
          this.$store.state.auth.user.uid
        );

        // サーバでのチェック結果を格納
        const checkWellchoCodeExists = functions.httpsCallable(
          "checkWellchoCodeExists"
        );
        const response = await checkWellchoCodeExists({
          code: code,
          userId: this.$store.state.auth.user.uid,
          diagnosisDate: this.$store.getters["karte/getDiagnosisDate"],
        });

        // 200以外はエラー表示にして処理を終了
        if (response.data.status !== 200) {
          this.validate(true);
          return;
        }
        // クーポンチェックの状態を管理
        this.charge = true;

        // 診断
        const querySelvasWithCoupon = await functions.httpsCallable(
          "querySelvasWithCoupon"
        );
        console.log(`code (${code})`);

        const aiResponse = await querySelvasWithCoupon(code);
      } catch (e) {
        throw new Error(e);
      } finally {
        this.$set(this.isProcessing, "flag", false);
      }
    },
  },
  created() {
    // 診断データを取得するためにリスナーを開始する
    this.listen();
  },
};
</script>

<style scoped></style>
